import React from "react";

const Loader = () => (
  <div className="wrapper wrapper-content" style={{ textAlign: "center" }}>
    <i className="fa fa-spinner fa-spin fa-spin-big" />
  </div>
);

export default Loader;
